module.exports = __webpack_public_path__ + "static/img/25@2x.5cfd6d34.png";